<template>
  <b-container fluid>
    <b-row>
      <b-col cols="12" class="header">
        <router-link to="/">
          <img src="./assets/logo.jpg" class="mcp-logo" />
        </router-link>
        <span v-if="CheckLogedin()">Vous êtes connecté</span>
      </b-col>
    </b-row>
    <b-container fluid class="boxApp">
      <b-row>
        <b-col cols="2" class="boxLeft">
          <div class="menu-left menu-left-app">
            <ul class="app-menu">
              <li v-if="CheckNeverConnected()">
                <button class="btn viewBtn" @click="GetSoumission()">Votre plan</button>
              </li>
              <li v-if="CheckLogedin()">
                <router-link to="/soumissions/">
                  <button class="btn viewBtn">
                    <font-awesome-icon icon="folder" />Plans
                  </button>
                  <!--<button class="btn viewBtn">Plans</button>-->
                </router-link>
              </li>
              <li v-if="CheckLogedin()">
                <router-link to="/soumissions/create/">
                  <button class="btn viewBtn">
                    <font-awesome-icon icon="plus" />Nouveau plan
                  </button>
                  <!--<button class="btn viewBtn">Nouveau plan</button>-->
                </router-link>
              </li>
              <li v-if="CheckNotLogedin()">
                <router-link to="/inscription/">
                  <button class="btn viewBtn">Inscription</button>
                </router-link>
              </li>
              <li v-if="CheckLogedin()">
                <router-link to="/profil/">
                  <button class="btn viewBtn">
                    <font-awesome-icon icon="id-badge" />Profil
                  </button>
                  <!--<button class="btn viewBtn">Profil</button>-->
                </router-link>
              </li>
              <li v-if="CheckNotLogedin()">
                <router-link to="/connexion/">
                  <button class="btn viewBtn">
                    <font-awesome-icon icon="sign-in-alt" />Connexion
                  </button>
                  <!--<button class="btn viewBtn">Login</button>-->
                </router-link>
              </li>
              <li v-if="CheckLogedin()">
                <button class="btn viewBtn" @click="LogOut()">
                  <font-awesome-icon icon="sign-out-alt" />Déconnexion
                </button>
                <!--<button class="btn viewBtn" @click="LogOut()">Logout</button>-->
              </li>
            </ul>
          </div>
        </b-col>
        <b-col cols="10" class="boxRight">
          <div class="right-section">
            <vue-page-transition name="fade-in-left">
              <router-view />
            </vue-page-transition>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <b-container fluid class="boxTooNarrow">
      <p>Votre écran est trop petit pour utiliser cette application.</p>
    </b-container>
  </b-container>
</template>

<script>
import { fabric } from "fabric";

export default {
  name: "App",
  data: () => ({
    hello: ""
  }),
  methods: {
    GetSoumission: function() {
      this.$router.push({
        name: "EditSoumission",
        params: { sid: localStorage.getItem("soumissionUID") }
      });
    },
    CheckLogedin: function() {
      if (localStorage.getItem("token")) {
        return true;
      } else {
        return false;
      }
    },
    CheckNotLogedin: function() {
      if (localStorage.getItem("token")) {
        return false;
      } else {
        return true;
      }
    },
    CheckNeverConnected: function() {
      if (localStorage.getItem("soumissionUID")) {
        return true;
      } else {
        return false;
      }
    },
    LogOut: function() {
      this.$bvModal
        .msgBoxConfirm("Voulez-vous vraiment vous déconnecter?", {
          title: "Confirmation",
          size: "sm",
          buttonSize: "sm",
          okVariant: "success",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true
        })
        .then(value => {
          if (value) {
            var dheader = {
              "Content-Type": "application/json",
              Authorization: "Token " + localStorage.getItem("token")
            };

            var data = { revoke_token: false };

            this.$http
              .post(this.$url_name + "/accounts/logout/", data, {
                headers: dheader
              })
              .then(response => {
                //console.log(response);
                localStorage.setItem("soumissionUID", "");
                localStorage.setItem("token", "");
                this.$router.push({ name: "Home" });
              })
              .catch(err => {
                console.log(err);
              });
          }
        });
    }
  }
};
</script>

<style>
body {
  overflow-x: hidden;
}
.errors {
  color: red;
}
a {
  text-decoration: none;
}
a,
a:link,
a:visited {
  color: #3399cc;
}
a:focus,
a:hover,
a:active {
  color: #000;
  text-decoration: none;
}

.mcp-logo{
  background-color:#fff;
  width:auto;
  height:70px;
  padding:0 40px;
}

.app-menu {
  list-style-type: none;
  padding-left: 0px;
}
.app-menu li {
  margin-bottom: 20px;
}
.boxApp.container-fluid {
  padding: 0;
}
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.section-left {
  width: 40%;
  float: left;
  overflow-y: scroll;
  padding-right: 20px;
  height: 725px;
}
.section-right {
  width: 60%;
  float: left;
}
#main-section {
  overflow-y: scroll;
  margin-top: 25px;
  height: 800px;
}
.table-produits th {
  text-align: center;
}
.header.col-12 {
  background-color: #f8f8f8;
  padding: 0;
}
.section-title {
  font-size: 16px;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 10px;
}
.options {
  background-color: #fff;
}
.options ul {
  list-style-type: none;
  padding-left: 30px;
}
.options ul li {
  padding-bottom: 10px;
  float: left;
  margin-right: 10px;
}
.options button {
  width: 70px;
}
.products ul {
  list-style-type: none;
}
.products ul li {
  float: left;
  padding-left: 2px;
  text-align: center;
}
.plan {
  padding-top: 25px;
}
.vos-plans ul {
  list-style-type: none;
}
.vos-plans ul li {
  padding-bottom: 10px;
}
.menu-left {
  height: calc(100vh - 95px);
  padding: 0;
  font-size: 12px;
}
.menu-left button {
  width: 100%;
  font-size: 12px;
}
.menu-left-app {
  padding-top: 25px;
}

.app-menu svg{margin-right:.5em}

.btn.viewBtn {
  background: transparent;
  border:1px solid #1e65a6;
  border-radius: 2px;
  color: #1e65a6;
  font-size: 12px;
  line-height: 16px;
  font-weight: 400;
  text-align: center;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  overflow: hidden;
  display: inline-block;
  position: relative;
  z-index: 1;
  opacity:.7;
  -webkit-transition: .3s;
  transition: .3s;
  padding: 1em 1.6em 0.85em;
}
.btn.viewBtn:hover {
  color:#555;
  border-color:#555;
  opacity:1
}

.boxTooNarrow {
  font-size: 20px;
  text-align: center;
  display: none;
  width: 80vw;
  margin: 30vh 10vw;
}
.col-2.boxLeft{
    background-color: #fff;
    border-right: 1px solid #eee;
    border-bottom: none;
    padding-bottom: 0
}
@media (max-width: 1199px) {
  .col-2.boxLeft,
  .col-10.boxRight {
    display: block;
    width: 100%;
    max-width: calc(100vw - 30px);
    -ms-flex: 0 1 auto;
    flex: 0 1 auto;
  }
  .col-2.boxLeft{
    border-right: none;
    border-bottom: 1px solid #eee;
    max-width:100%;
    padding-bottom: 15px
  }
  .col-2.boxLeft .menu-left {
    height: auto;
  }
  .col-2.boxLeft .app-menu {
    margin: 0;
  }
  .col-2.boxLeft .app-menu li {
    display: inline-block;
    margin: 1px 5px;
  }
  .col-10.boxRight .right-section {
    margin: 0;
  }
}

@media (max-width: 499px) {
  .boxApp {
    display: none;
  }
  .boxTooNarrow {
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue